var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1110.12 302.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.4,532.71l-57.52-36.07V540l57.52,36.07L693.09,474.62a150.52,150.52,0,0,0-18.11-30Z",
    transform: "translate(-404.29 -385.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M706.51,537a151.93,151.93,0,0,0-2.42-27.07l-32.53,24c0,1,.05,2.07.05,3.1A116.31,116.31,0,1,1,620.92,441l29.39-21.66A151.11,151.11,0,1,0,706.51,537Z",
    transform: "translate(-404.29 -385.85)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "880.19 90.46 921.27 60.19 783.78 60.19 783.78 242.04 921.27 242.04 921.27 211.76 823.02 211.76 823.02 165.2 906.83 165.2 906.83 134.92 823.02 134.92 823.02 90.46 880.19 90.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1084.29,516.93h-47.75V476.32h76.22L1153.85,446H997.3V627.89h81.93c46,0,72.31-20.82,72.31-57.12C1151.54,536.05,1127.66,516.93,1084.29,516.93Zm-6.83,80.68h-40.92v-50.4h40.92c24.9,0,36.5,8.43,36.5,25.2C1114,589.54,1101.68,597.61,1077.46,597.61Z",
    transform: "translate(-404.29 -385.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437,446H1362.1V627.89h39.24V576.38H1437c47.78,0,77.45-25.12,77.45-65.26S1484.74,446,1437,446Zm-.84,100.06h-34.78V476.32h34.78c25.15,0,39,12.39,39,34.89S1461.27,546.1,1436.12,546.1Z",
    transform: "translate(-404.29 -385.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M929.94,588.52A70.21,70.21,0,0,1,896.07,597C860.69,597,835,571.75,835,537s25.67-60,61.05-60a59.84,59.84,0,0,1,35.69,11.17l28.14-20.74h0L958,465.72c-16.43-14.44-38.39-22.07-63.49-22.07-27.23,0-51.95,9.18-69.59,25.86S797.44,509.88,797.44,536s9.74,50.15,27.42,67.43,42.4,26.89,69.44,26.89c28.29,0,53-9.86,69.73-27.81l-25.39-18.71Z",
    transform: "translate(-404.29 -385.85)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSber);
export default __webpack_public_path__ + "static/media/sber.7d0569ba9945d29ec0a7eee4e35f3bfd.svg";
export { ForwardRef as ReactComponent };